export enum AgentStatusTypes {
  Routable = 'ROUTABLE',
  OnCall = 'ON_CALL',
  ACW = 'ACW',
  Custom = 'CUSTOM',
  Error = 'ERROR',
}

export type AgentStatusType = `${AgentStatusTypes}`;
